import { queryOptions } from '@tanstack/react-query';

import { RQ_TRENDING_SEARCHES } from '../ReactQuery/cacheKeys';
import { type SupportedLocation } from '../location/constants';

import { getTrendingSearchesContent } from './getTrendingSearchesContent';

export function trendingSearchesQueryOptions(location: SupportedLocation) {
  return queryOptions({
    queryKey: [RQ_TRENDING_SEARCHES, location],
    queryFn: () => getTrendingSearchesContent(location),
  });
}
